module.exports = __webpack_public_path__ + "img/img-question-3-teaching-course-online-video.ce618e9b.jpg";